import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import { Pressable, View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

interface TagProps {
  text: string;
  onClose: () => void;
  displayCross?: boolean;
}

export function Tag({ text, onClose, displayCross = true }: TagProps) {
  const content = (
    <Row
      alignItems="center"
      backgroundColor="surface.inverse.tertiary-neutral"
      borderRadius="radius.xl"
      paddingLeft="spacing.general.x4"
      paddingVertical="spacing.general.x2"
    >
      <Text fontSize={14} fontWeight="700">
        {text}
      </Text>
      {displayCross ? (
        <View style={{ marginRight: theme.spacing['spacing.general.x1'] }}>
          <IconX strokeWidth={ICON_STROKE_WIDTH} size={18} />
        </View>
      ) : null}
    </Row>
  );

  if (displayCross) {
    return <Pressable onPress={onClose}>{content}</Pressable>;
  }

  return content;
}
